import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LocaleService } from '@next/core-lib/i18n';
import { NavigationActions } from '@next/core-lib/navigation';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';
import { Store } from '@ngrx/store';

import { SiteState } from './shared/models';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, AgrWrapperSiteSidenavModule],
})
export class AppComponent implements OnInit {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly locale = inject(LocaleService);

  readonly navigationItems = [
    {
      relativeUrl: '/monitor-import',
      label: 'screen-titles.monitor-import',
    },
    {
      relativeUrl: '/notifications-import',
      label: 'screen-titles.notifications-import',
    },
  ];
  direction$ = this.locale.direction$;

  ngOnInit(): void {
    this.store.dispatch(
      NavigationActions.setNavigationItems({
        navigationItems: this.navigationItems,
      }),
    );
  }
}
